module.exports = __webpack_public_path__ + "static/img/bannerImg2Detail.de9262f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/home/bannerImg2Detail.jpg
// module id = PaZP
// module chunks = 14